<template>
  <div class="custom-tree">
    <el-input v-model="searchKeyword" placeholder="请输入机构名称" size="small" clearable style="margin-bottom: 8px;"
      @keyup.enter.native="onSearch">
      <template slot="append">
        <div @click="onSearch">
          <i slot="suffix" class="el-icon-search"></i>
        </div>
      </template>
    </el-input>
    <div class="tree-list">
      <ul>
        <li v-for="item in filteredTreeData" :key="item.organizationId" class="province"
          @click="selectCity(item)" :class="{ active: item.organizationId == selectedCityKey }">
          <span class="province-name">{{ item.organizationName }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * 带搜索的树形城市选择组件
 * @module CustomTree
 */
export default {
  name: 'CustomOrgTree',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      treeData: [],
      searchKeyword: '',
      selectedCityKey: null,
      filteredTreeData: []
    }
  },
  created() {
    /**
     * 初始化时默认选中第一项
     * 如果第一项有children，则选中其第一个子项
     * 否则选中第一项本身
     */
    this.getOrgData()
  },
  computed: {
  },
  methods: {
    onSearch() {
      this.filteredTreeData = this.searchData()
    },
    searchData() {
      if (!this.searchKeyword) return this.treeData
      const keyword = this.searchKeyword.trim()
      // 过滤逻辑：如果当前项没有children，则直接匹配当前项
      return this.treeData
        .map(item => {
          return item.organizationName.includes(keyword) ? item : null
        })
        .filter(Boolean)
    },
    async getOrgData(isrefresh = false) {
      const { code, data } = await this.$axios.get(this.url,{
        page: 1,
        size: 500
      })
      if (code === 1) {
        this.treeData = data
        if (this.treeData && this.treeData.length > 0 && !isrefresh) {
          const firstItem = this.treeData[0]
          this.selectedCityKey = firstItem.organizationId
          this.$emit('selected', firstItem)
        }

        this.filteredTreeData = this.searchData()
      }
    },
    /**
     * 选择项
     * @param {Object} city
     */
    selectCity(city) {
      this.selectedCityKey = city.organizationId
      this.$emit('selected', city)
    }
  }
}
</script>

<style lang="less" scoped>
.custom-tree {
  width: 200px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #eee;
  padding: 8px;

  /deep/ .el-input-group__append {
    padding: 0;
    background: #f3f3f3 !important;

    div {
      padding: 0 16px;
      cursor: pointer;
    }
  }
}

.tree-list {
  max-height: calc(100vh - 240px);
  overflow-y: auto;

}

.province {
  color: #999;
  font-size: 13px;
}

.province-name {
  font-weight: bold;
  margin-bottom: 2px;
  display: inline-block;
  display: block;
  padding: 8px;
  cursor: pointer;
}

.active {
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 2px;
}
</style>
